module.exports = __webpack_public_path__ + "assets-cabinet/img/card-icon.ac628493.svg";